import { module } from 'modujs';
import LazyLoad from "vanilla-lazyload";
//import axios from 'axios';

export default class extends module {
    constructor(m) {
        super(m);
        this.target = document.querySelector( this.el.dataset.target );
        this.query = this.el.dataset.query || '';
        if( ! this.target ) {
            console.warn( 'Loading Button: target container "' + this.el.dataset.target + '" not found .' );
            return;
        }
        this.reset();

        this.el.addEventListener( 'click', (e) => {
            e.preventDefault();
            this.el.classList.add( 'loading' );
            this.page++;
            axios.get( this.el.href + 'page/' + this.page + this.query ).then( (response) => {
                const doc = document.createElement("div");
                doc.innerHTML = response.data;
                this.target.innerHTML = this.target.innerHTML + doc.querySelector(this.el.dataset.target ).innerHTML;
                this.el.classList.remove( 'loading' );
                this.el.classList.toggle( 'hidden', this.page === this.maxNumPages );
                new LazyLoad({ elements_selector : '[data-scroll-call="toggleLazy,Scroll"]', container: document.querySelector( this.el.dataset.target ) });
                console.info(document.querySelector( this.el.dataset.target ));
                this.call('update', false, 'Scroll');
            });
        });
    }
    reset(){
        this.page = 1;
        this.maxNumPages = parseInt( this.el.dataset.maxNumPages );
    }
    init() {}
    destroy(){}
}
